var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9478 19.9425C21.7993 19.9425 23.2982 18.4437 23.2982 16.5922C23.2982 14.7407 21.7993 13.2418 19.9478 13.2418C19.9363 13.2418 19.9248 13.2418 19.9133 13.2418C19.6182 10.5777 17.3527 8.5 14.6003 8.5C12.4268 8.5 10.56 9.79567 9.72433 11.6548C9.6975 11.6548 9.67067 11.651 9.64383 11.651C7.35533 11.651 5.5 13.5063 5.5 15.7948C5.5 18.0833 7.35533 19.9387 9.64383 19.9387",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0803 19.9397C21.8702 19.8702 23.298 18.3991 23.298 16.592C23.298 14.7405 21.7992 13.2416 19.9477 13.2416H19.9132C19.9028 13.1484 19.8901 13.0559 19.875 12.9641C20.2421 12.8263 20.6399 12.751 21.0554 12.751C22.7804 12.751 24.2026 14.0543 24.3904 15.7333H24.4134C25.5749 15.7333 26.5179 16.6763 26.5179 17.8378C26.5179 18.9993 25.5749 19.9423 24.4134 19.9423L20.0803 19.9397Z",
    fill: "#CAD1E0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9404 24.4077C15.8568 24.456 15.7604 24.4822 15.6562 24.4833C15.342 24.4844 15.0887 24.2274 15.0891 23.9157L15.0899 22.276C15.0889 21.9619 15.342 21.7076 15.6575 21.709C15.9717 21.7079 16.225 21.9649 16.2246 22.2766L16.2238 23.9163C16.2237 24.1262 16.11 24.3098 15.9404 24.4077Z",
    fill: "url(#paint0_linear_4805_26893)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9013 23.7947C19.8177 23.843 19.7213 23.8691 19.6171 23.8703C19.303 23.8713 19.0497 23.6143 19.0501 23.3027L19.0508 21.663C19.0498 21.3488 19.3029 21.0945 19.6185 21.0959C19.9326 21.0949 20.1859 21.3519 20.1855 21.6636L20.1847 23.3032C20.1846 23.5131 20.071 23.6968 19.9013 23.7947Z",
    fill: "url(#paint1_linear_4805_26893)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2695 23.7945C12.1859 23.8427 12.0895 23.8689 11.9853 23.87C11.6711 23.8711 11.4178 23.6141 11.4182 23.3024L11.419 21.6627C11.418 21.3486 11.6711 21.0943 11.9866 21.0957C12.3008 21.0946 12.5541 21.3516 12.5537 21.6633L12.5529 23.303C12.5528 23.5129 12.4391 23.6965 12.2695 23.7945Z",
    fill: "url(#paint2_linear_4805_26893)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4805_26893",
    x1: 14.8093,
    y1: 23.5839,
    x2: 16.5028,
    y2: 22.6061,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00BDF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4805_26893",
    x1: 18.7707,
    y1: 22.9706,
    x2: 20.4642,
    y2: 21.9928,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00BDF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4805_26893",
    x1: 11.1388,
    y1: 22.9704,
    x2: 12.8324,
    y2: 21.9926,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00BDF2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRain);
export default __webpack_public_path__ + "static/media/rain.884037d1ce06be687cc64a62f98067a6.svg";
export { ForwardRef as ReactComponent };